import { Box } from "@chakra-ui/react";
import { FC } from "react";

import { Checkbox, CheckboxProps } from "~/src/components/common/Checkbox";
import { chakraFactory } from "~/src/lib/chakra-ui";

import { columnStyles } from "../styles";

export type Props = {
  isChecked: CheckboxProps["isChecked"];
  onChange: CheckboxProps["onChange"];
};

const StyledHeaderColumnBox = chakraFactory(Box, {
  baseStyle: {
    ...columnStyles,
    justifyContent: "center",
    maxWidth: "40px",
    minWidth: "40px",
  },
});

export const TableHeaderCheckboxColumn: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ isChecked, onChange }) => (
  <StyledHeaderColumnBox>
    <Checkbox iconType="hyphen" isChecked={isChecked} onChange={onChange} />
  </StyledHeaderColumnBox>
);
